/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import SearchService from '../services/search-service.js';
import Recorder from 'react-recorder'
import ContentService from '../services/content-service.js';
import $ from 'jquery';
import ContentStore from '../store/content-store.js';
import { FormattedMessage } from 'react-intl';
import Config from '../classes/config.js';
import InternationalizationStore from '../store/internationalization-store.js'
function isDataUrl(s){
    let regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

    return !!s.match(regex);
}

import RecorderUpload from './recorderUpload.js';
import ImageUpload from './imageUpload.js';

export default class ContentModel  extends React.Component {

    constructor(props){
        super();
        this.state = {edit:props.edit, vocabUID:props.vocabUID, show:props.show , learningText:'' , summary:ContentStore.getCatalogSummary(props.catalogUID).summary};
        this.toggleVocab = props.onToggle || this.toggleVocab.bind(this)
        this.learningText = '';
        this.props = props;

        this.base = Config.getBaseUrl();
        this.imageBase = Config.getImagePath();
        this.audioBase = Config.getAudioBaseUrl();
    }

    componentWillReceiveProps(props){
        this.props = props;
        console.log(this.props);
        this.setState({show:props.show})
    }

    componentWillMount() {
       // ContentService.fetchCatalogSummary(this.props.catalogUID)
    }

    componentDidMount() {

        ContentStore.on('ON_SUMMARY_FETCH'  , () => {
            this.setState({
                summary:ContentStore.getCatalogSummary(this.props.catalogUID).summary
            });
        });
    }


    handelKeyDown(){
        if(this.state.isedit) return;
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){

        if(this.state.isedit) return;
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){

                if(this.learningText.value.length <= 0) return;
                SearchService.searchLearning(this.learningText.value , this.state.summary.learning_ietf , this.state.summary.support_ietf).then(function(response){

                    var searchResults = response.searchResults;

                    for(var idx = 0 ; idx < searchResults.length; idx++)
                    {
                        if(String(this.learningText.value).toLowerCase() ==  String(searchResults[idx].word).toLowerCase())
                        {
                            this.learningText.value = searchResults[idx].word;

                            this.imageDataUrl =  searchResults[idx].picture;
                            this.learnDataUrl =  searchResults[idx].learningAudio;


                            if(this.state.summary.learning_ietf != this.state.summary.support_ietf)
                            {
                                this.supportText.value  = searchResults[idx].support;
                                this.supportDataUrl =  searchResults[idx].supportAudio;
                            }

                            this.setState({supportAudio:this.audioBase + searchResults[idx].supportAudio  , learningAudio:this.audioBase + searchResults[idx].learningAudio , imagePreviewUrl: this.imageBase + this.imageDataUrl});
                            return;
                        }
                    }


                }.bind(this));

            }.bind(this), 500)
        });
    }

    handelPreviewPlay(src){
        this.audio = new Audio(src);
        this.audio.play();
    }

    handelRecording(preview){

    }

    getDataUrl(){

    }

    onSubmit(){

        this.imageDataUrl =  this.imageDataUrl ?  this.imageDataUrl : "";
        this.learnDataUrl =  this.learnDataUrl ?  this.learnDataUrl : "";
        this.supportDataUrl =  this.supportDataUrl ?  this.supportDataUrl : "";

        let learningVocab = this.learningText ? this.learningText.value || ""  : "";
        let supportVocab  = this.supportText  ? this.supportText.value  || ""  : "";
        let DataUrls      = [{} , {} , {}];
        let imageIsDataURL   = isDataUrl(this.imageDataUrl || "");
        let learnIsDataURL   = isDataUrl(this.learnDataUrl || "");
        let supportIsDataURL = isDataUrl(this.supportDataUrl || "");

        if(this.state.summary.learning_ietf == this.state.summary.support_ietf)
        {
            supportVocab = learningVocab;
            supportIsDataURL =  learnIsDataURL;
            this.supportDataUrl = this.learnDataUrl;
        }

        this.imageDataUrl = imageIsDataURL ?  this.imageDataUrl : this.imageDataUrl.replace(this.imageBase  , "");
        this.learnDataUrl = supportIsDataURL ? this.learnDataUrl : this.learnDataUrl.replace(this.audioBase , "");
        this.supportDataUrl = learnIsDataURL ? this.supportDataUrl :this.supportDataUrl.replace(this.audioBase , "");

        this.setState({progress:true})

        ContentService.makeVocab(this.props.catalogUID , this.state.summary.learning_ietf , this.state.summary.support_ietf , learningVocab , supportVocab , imageIsDataURL , this.imageDataUrl , learnIsDataURL , supportIsDataURL , this.learnDataUrl , this.supportDataUrl).then(function(){
            this.toggleVocab();
            this.setState({progress:false})
            ContentService.fetchCatalogSummary(this.props.catalogUID)
        }.bind(this));

    }

    form(){
        let Style={display:'table-cell'};
        let Support = null;

        if(this.state.summary.learning_ietf != this.state.summary.support_ietf)
        {
           Support =  <div className="m-t-10 Large-input-height">
               <div style={Style} className="p-0 vert-center" md={1}><img className="avatar-img" src={"img/flags/"+this.state.summary.support_ietf+".png"} alt=""/></div>
               <div style={Style} className="p-t-25 vert-bottom" md={7}><FormGroup className="fg-line">
                   <FormControl inputRef={ref => { this.supportText = ref; }}   placeholder={InternationalizationStore.getTranslation("ui-2219" , "Enter translation")} type="text" onChange={this.handelClassNameChange}/></FormGroup></div>
               <div style={Style} className="p-5 vert-center" md={4}>

                   <RecorderUpload onChange={(dataURL)=>{this.supportDataUrl = dataURL}} audioPreview={this.state.supportAudio} />
               </div>

           </div>
        }

        return  <Row>
            <Col md={7}>
                <div  className="m-t-20 Large-input-height">
                    <div style={Style} className="p-0 vert-center" md={1}><img className="avatar-img" src={"img/flags/"+this.state.summary.learning_ietf+".png"} alt=""/></div>
                    <div style={Style} className="p-t-25 vert-bottom" md={7}><FormGroup className="fg-line fg-toggled">
                        <FormControl inputRef={ref => { this.learningText = ref; }} onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)} autoFocus  placeholder={InternationalizationStore.getTranslation("ui-2219" , "Enter translation")} type="text" onChange={this.handelClassNameChange}/></FormGroup></div>
                    <div style={Style} className="p-5 vert-center" md={4}><RecorderUpload onChange={(dataURL)=>{this.learnDataUrl = dataURL}} audioPreview={this.state.learningAudio} onRecord={this.handelRecording.bind(this)} /></div>
                </div>
                <br />
                {Support}
            </Col>
            <Col md={5}>
                <ImageUpload onChange={(dataURL)=>{this.imageDataUrl = dataURL}} imagePreviewUrl={this.state.imagePreviewUrl}/>
            </Col>
        </Row>
    }

    progress(){
        return <div>
                    <Row><Col sm={2} smOffset={5} >
            <div className="preloader pl-xl pls-blue">
                <svg className="pl-circular" viewBox="25 25 50 50">
                    <circle className="plc-path" cx="50" cy="50" r="20"/>
                </svg>
            </div>
        </Col></Row></div>
    }

    render(){

        let body = this.form();
        let footer =  [<Button onClick={this.toggleVocab} bsStyle="danger"><FormattedMessage id={"ui-74"} defaultMessage={"Content Libary"} /></Button>, <Button onClick={this.onSubmit.bind(this)} bsStyle="primary"><FormattedMessage id={"ui-336"} defaultMessage={"Content Libary"} /></Button>];

        if(this.state.progress)
        {
            body = this.progress();
            footer = null;
        }



        return  <Modal bsSize="large"  show={this.state.show} onHide={this.toggleVocab}>
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage id={"ui-336"} defaultMessage={"Content Libary"} /></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
            {footer}
            </Modal.Footer>

        </Modal>
    }
}



// WEBPACK FOOTER //
// ./src/components/content-model.js